import React, { useEffect, useState } from 'react';
import { Table, Button, Popconfirm, Space, message, Spin } from 'antd';
import { EditOutlined, StopOutlined, PlusOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { userRequests } from '../../requests';
import './UserList.scss';

const UserList = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const fetchUsers = async () => {
    setLoading(true);
    try {
      const response = await userRequests.getAll();
      setUsers(response.data);
    } catch (error) {
      message.error('Error fetching users');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUsers();
  }, []);

  const handleEdit = (id) => {
    navigate(`/usuarios/editar/${id}`);
  };

  const handleEnable = async (id, active) => {
    try {
      const action = active ? 'ativado' : 'desativado';
      await userRequests.enable(id, active);
      message.success(`Usuário ${action} com sucesso`);
      fetchUsers();
    } catch (error) {
      const action = active ? 'ativar' : 'desativar';
      message.error(`Erro ao ${action} usuário`);
    }
  };

  const columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Nome completo',
      dataIndex: 'fullName',
      key: 'fullName',
    },
    {
      title: 'Ativo',
      dataIndex: 'active',
      key: 'active',
      render: (active) => (active ? 'Sim' : 'Não'),
    },
    {
      title: 'Ações',
      key: 'actions',
      render: (text, record) => (
        <Space>
          <EditOutlined
            style={{ color: 'blue', cursor: 'pointer' }}
            onClick={() => handleEdit(record.id)}
          />
          {record.active ? (
            <Popconfirm
              title="Tem certeza que deseja desativar este usuário?"
              onConfirm={() => handleEnable(record.id, false)}
              okText="Sim"
              cancelText="Não"
            >
              <StopOutlined style={{ color: 'red', cursor: 'pointer' }} />
            </Popconfirm>
          ) : (
            <Popconfirm
              title="Tem certeza que deseja desativar este usuário?"
              onConfirm={() => handleEnable(record.id, true)}
              okText="Sim"
              cancelText="Não"
            >
              <CheckCircleOutlined style={{ color: 'red', cursor: 'pointer' }} />
            </Popconfirm>
          )}
        </Space>
      ),
    },
  ];

  return (
    <div className="UserList">
      <Space style={{ marginBottom: 16 }}>
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={() => navigate('/usuarios/registrar')}
        >
          Adicionar novo
        </Button>
      </Space>
      <Spin spinning={loading}>
        <Table columns={columns} dataSource={users} rowKey="id" />
      </Spin>
    </div>
  );
};

export default UserList;
